import React from "react"
import {graphql,useStaticQuery} from 'gatsby'
import { Link } from "gatsby"

import { 
  Wrapper,
  InnerDiv,
  ImageBackGround,
  Image,
  SideDiv
} from "./style"
import Social from "../../constants/socialLinks"

const query = graphql`
  {
    file(relativePath: { eq: "me.jpg" }) {
      childImageSharp {
        fixed(width: 120, height: 120) {
          ...GatsbyImageSharpFixed
        }
      }
    }
  }
`

const Home = ({children,isOpen}) => {
  const data = useStaticQuery(query);
  const {file:{childImageSharp:{fixed}}} = data
  
  return (
    <>
      <Wrapper>
        <SideDiv>
          <ImageBackGround keepOpened={isOpen}>
            <InnerDiv>
              <Link to={"/"}>
                <Image fixed={fixed} />
              </Link>
              <h1>
                <strong>Hello there</strong>, I am
                <br />
                Frederick, a fullstack software engineer
                <br />
              </h1>
            </InnerDiv>
            <Social />
          </ImageBackGround>
        </SideDiv>
        {children}
      </Wrapper>
    </>
  )
}


export default Home